<template>
    <div class="topcode-wechat-layout" :style="{marginTop:top+'px'}">
        <div class="header-bar" :style="{top:top+'px'}" ref="header-bar">
            <slot name="header-bar"></slot>
        </div>
        <div class="show-bar" :style="{top:headerHeight+'px'}" ref="show-bar">
            <slot name="show-bar"></slot>
        </div>
        <div class="occupy-bar" :style="{height:barHeight+'px'}"></div>
        <slot/>
    </div>

</template>

<script>
    export default {
        name: 'layout',
        props: {
            top: {type: Number, default: 0}
        },
        data() {

            return {
                headerHeight: 0, barHeight: 0
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                const headerBar = this.$refs['header-bar']
                this.headerHeight = headerBar.offsetHeight
                const showBar = this.$refs['show-bar']
                this.barHeight = this.headerHeight + showBar.offsetHeight - this.top
            }
        }
    }
</script>

<style lang="less" scoped>

    .topcode-wechat-layout {
        height: 100%;
        width: 100%;
        overflow-y: hidden;

        & > .header-bar {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 2;
        }
        & > .show-bar {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 2;
        }
        & > .occupy-bar {
            height: 0px;
            width: 100%;
        }
    }

</style>